import { render } from "./Alignment.vue?vue&type=template&id=9f37840e"
import script from "./Alignment.vue?vue&type=script&lang=js"
export * from "./Alignment.vue?vue&type=script&lang=js"
script.render = render

export default script